import React from 'react';
import Slide from './Slide';
import { useHorizontalScroll } from 'utils/hooks';

import * as styles from './ScrollSlider.module.scss';

export default function ScrollSlider({ projects }) {
  const scrollRef = useHorizontalScroll();

  return (
    <div className={styles.wrapper} ref={scrollRef}>
      {projects.map(project => (
        <Slide key={project.link} {...project} />
      ))}
    </div>
  );
}
